<div #dynamic cupcakeDynamic [type]="component" [inputs]="inputs" [outputs]="outputs"></div>